import { valueof } from "api/common/utils/type.utils";

export interface CountryId {
  name: string;
  name_iso: string | null;
  code2_iso: string;
  code3_iso: string;
}

// TODO: move to Organization endpoints once made
export const ORGANIZATION_TYPES = {
  LAB: "Lab",
  VENDOR: "Vendor",
  NIAP: "NIAP",
  VALIDATOR: "Validator",
  CCP_VENDOR: "CCP Vendor",
} as const;
export type OrganizationType = valueof<typeof ORGANIZATION_TYPES>;

// TODO: move to Organization endpoints once made
export interface Organization {
  name: string;
  org_id: number;
  poc_email: string;
  poc: string;
  archived?: boolean;
  ext_phone?: string | null;
  logo?: string | null;
  org_type?: OrganizationType;
  poc_title?: string | null;
  primary_address_1: string;
  primary_address_2: string | null;
  primary_city: string;
  primary_country: string;
  primary_fax: string | null;
  primary_phone: string;
  primary_state: string; // TODO: create State type if youre feeling ambitious
  primary_zip: string; // Could also do a zip type?
  website?: string;
}

export interface OrgStub {
  org_id: number;
  name: string;
}

export interface Option {
  label: string;
  value: string | number;
}
export interface TypedOption<T> {
  label: string;
  value: T;
}

// This is a type guard to check whether an array contains Option types
export const isOptionArray = (arr: unknown[]): arr is Option[] => {
  return (
    arr.length > 0 &&
    arr.every(
      (item) =>
        typeof item === "object" &&
        item !== null &&
        "value" in item &&
        "label" in item &&
        typeof (item as any).label === "string" &&
        (typeof (item as any).value === "string" ||
          typeof (item as any).value === "number"),
    )
  );
};
